// Small shared modal notice for the mobile UI — a centered card with a red badge, title, message
// and a dismiss button. Used to surface blocking errors (e.g. trying to trade an untradable
// player) that would otherwise fail silently, since logEvent toasts are suppressed in this UI.
// Renders nothing when `message` is falsy.

export const MobileNotice = ({
	message,
	title = "Can't do that",
	variant = "error",
	onClose,
}: {
	message: string | null;
	title?: string;
	variant?: "error" | "success";
	onClose: () => void;
}) => {
	if (!message) {
		return null;
	}
	return (
		<div className="mnotice-overlay" onClick={onClose}>
			<style>{styles}</style>
			<div className="mnotice" onClick={(e) => e.stopPropagation()}>
				<div className={`mnotice-badge mnotice-badge-${variant}`}>
					{variant === "success" ? "✓" : "✕"}
				</div>
				<div className="mnotice-title">{title}</div>
				<div className="mnotice-msg">{message}</div>
				<button className="mnotice-btn" onClick={onClose}>
					Got it
				</button>
			</div>
		</div>
	);
};

const styles = `
.mnotice-overlay { position:fixed; inset:0; z-index:2100; background:rgba(0,0,0,.55);
  display:flex; align-items:flex-end; justify-content:center; padding:16px;
  font-family:Montserrat,system-ui,sans-serif; }
.mnotice { width:100%; max-width:560px; background:#181818; border:1px solid #2a2a2a;
  border-radius:20px; padding:22px 20px; text-align:center; color:#fff; }
@media (min-width:640px){ .mnotice-overlay{ align-items:center } }
.mnotice-badge { width:52px; height:52px; border-radius:50%; margin:4px auto 12px;
  display:flex; align-items:center; justify-content:center; font-size:22px; font-weight:900; }
.mnotice-badge-error { background:rgba(226,80,78,.16); color:#E2504E; }
.mnotice-badge-success { background:rgba(24,224,168,.16); color:#18E0A8; }
.mnotice-title { font-size:20px; font-weight:900; letter-spacing:-.3px; margin-bottom:8px; }
.mnotice-msg { font-size:14px; font-weight:600; color:#9fb0bc; line-height:1.5; margin-bottom:18px; }
.mnotice-btn { width:100%; border:none; border-radius:26px; background:#18E0A8; color:#0a0a0a;
  font-weight:800; font-size:15px; padding:14px; cursor:pointer; font-family:inherit;
  box-shadow:0 10px 26px rgba(24,224,168,.3); }
`;

export default MobileNotice;
